import { dataLoaded } from "@/event/dataLoaded"
import { configWebMessageSpecial } from "@/storage/setting/configWebMessageSpecial"
import { configWebMessageSpecialStatus } from "@/storage/setting/configWebMessageSpecialStatus"
import { computed } from "vue"

export const showBannerMessageSpecial = computed(() => {
    const status = Number(configWebMessageSpecialStatus.value)
    return status > 0 && configWebMessageSpecial.value.length > 0 && dataLoaded.value === 2
})